import React, {Component} from 'react';
import '../splash-screen.css';
import Home from './Home'
import logo from '../logo (2).png';
import '../App.css';

function LoadingMessage() {
    return (
        <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
        </header>
        /*<div className="splash-screen">
            Wait a moment while we load your app.
            <div className="loading-dot">.</div>
        </div>*/
    );
}

function withSplashScreen(WrappedComponent) {
    return class extends Component {
        constructor(props) {
            super(props);
            this.state = {
                loading: true,
            };
        }

        async componentDidMount() {
            try {

                setTimeout(() => {
                    this.setState({
                        loading: false,
                    });
                }, 3000)
            } catch (err) {
                console.log(err);
                this.setState({
                    loading: false,
                });
            }
        }

        render() {
            // while checking user session, show "loading" message
            if (this.state.loading) return LoadingMessage();

            // otherwise, show the desired route /*<img src={logo} className="App-logo" alt="logo" />*/
            return <Home />;
        }
    };
}

export default withSplashScreen;